import { Reveal, SectionTag } from "./Reveal";
import { WORKSTREAMS, IMG } from "../data/content";

export default function WorkProgramme() {
  return (
    <section id="programme" data-testid="work-programme-section" className="relative py-24 lg:py-32 bg-abyss/40">
      <div className="absolute inset-0 grid-overlay opacity-40 pointer-events-none" />
      <div className="relative max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal>
          <SectionTag index="03" label="Scientific Work Programme" />
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-ice leading-[0.95] max-w-3xl">
              Four proposed <span className="text-polar">workstreams</span>
            </h2>
            <p className="max-w-md text-sm text-ice/60 leading-relaxed lg:text-right">
              Proposed activities only — subject to scientific collaboration, technical feasibility and all required
              permissions.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-14" data-testid="workstream-grid">
          {WORKSTREAMS.map((w, i) => (
            <Reveal key={w.code} delay={0.08 * i}>
              <article
                className="group relative bg-[#0B1F35]/80 backdrop-blur-md border border-polar/15 p-7 sm:p-9 h-full overflow-hidden hover:border-polar/45 transition-colors duration-300"
                data-testid={`workstream-card-${w.code.toLowerCase()}`}
              >
                <span className="absolute -top-6 -right-2 font-display font-extrabold text-[7rem] leading-none text-polar/5 select-none group-hover:text-polar/10 transition-colors duration-500" aria-hidden="true">
                  {w.code.split("-")[1]}
                </span>
                <span className="font-mono text-[11px] tracking-[0.3em] text-mission">{w.code}</span>
                <h3 className="font-display font-semibold text-2xl sm:text-3xl text-ice mt-3 tracking-wide">{w.title}</h3>
                <ul className="mt-6 space-y-3">
                  {w.items.map((it) => (
                    <li key={it} className="flex gap-3 text-sm sm:text-base text-ice/65 leading-snug">
                      <span className="text-gold shrink-0">▸</span>
                      {it}
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[IMG.vessel1, IMG.glacier, IMG.vessel2].map((src, i) => (
              <div key={src} className="relative clip-corner overflow-hidden group" data-testid={`programme-gallery-${i}`}>
                <img
                  src={src}
                  alt={["Polar research vessel in icy waters", "Antarctic glacier reflected in calm water", "Expedition vessel near ice formations"][i]}
                  className="w-full h-48 sm:h-56 object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-abyss/30 group-hover:bg-abyss/10 transition-colors duration-500" />
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
